export function validateEmail( str ) {
  return /\S+@\S+/.test( str );
}

export function validatePhone( str ) {
  // eslint-disable-next-line max-len
  return /^([0-1]([\s-./\\])?)?(\(?[2-9]\d{2}\)?|[2-9]\d{3})([\s-./\\])?(\d{3}([\s-./\\])?\d{4}|[a-zA-Z0-9]{7})$/.test( str );
}

export function addError( inp ) {
  let parent = inp.parentNode;
  parent.classList.add('error');
  return inp;
}

export function removeError( inp ) {
  let parent = inp.parentNode;
  parent.classList.remove('error');
  return inp;
}

export function isEmpty( inp ) {
  return !inp.value || inp.value === 'none';
}

export function isNotSubmit( inp ) {
  return inp.type !== 'submit';
}

export function shouldValidate( inp ) {
  return inp.dataset.validate !== undefined;
}
